<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
  >
    <g filter="url(#filter0_d_13546_4911)">
      <g filter="url(#filter1_i_13546_4911)">
        <circle cx="18.5" cy="17" r="16" fill="#FF8D3A" />
      </g>
      <circle cx="18.5" cy="17" r="15.75" stroke="#FF8D3A" stroke-width="0.5" />
      <g filter="url(#filter2_d_13546_4911)">
        <circle
          cx="18.4996"
          cy="17"
          r="14.5"
          stroke="white"
          stroke-width="0.5"
          stroke-linecap="round"
          stroke-dasharray="0 1"
          shape-rendering="crispEdges"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_13546_4911"
        x="0.5"
        y="-1.19209e-07"
        width="36"
        height="36"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13546_4911"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_13546_4911"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_i_13546_4911"
        x="2.5"
        y="1"
        width="32"
        height="33"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_13546_4911"
        />
      </filter>
      <filter
        id="filter2_d_13546_4911"
        x="3.24957"
        y="2.25"
        width="30.5"
        height="30.5"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.5" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13546_4911"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_13546_4911"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
